import {FC} from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  FieldProps,
  Labeled,
  List,
  NumberField,
  SelectField,
  SimpleForm,
  TextField,
  TextInput,
  required,
} from 'react-admin';
import {NoticePushStatus, NoticePushStatusNames} from '../common/types';

const pushStatusChoices = Object.values(NoticePushStatus).map(value => ({
  id: value,
  name: NoticePushStatusNames[value],
}));

export const NoticeList = () => (
  <List sort={{field: 'createdAt', order: 'DESC'}} exporter={false}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField label="제목" source="title" />
      <BooleanField label="활성" source="enabled" />
      <SelectField
        label="앱 푸시"
        source="pushStatus"
        choices={pushStatusChoices}
        emptyText="-"
      />
      <DateField label="등록일" source="createdAt" />
      <NumberField label="조회수" source="viewCount" />
    </Datagrid>
  </List>
);

//
// Edit
const NoticeTitle: FC<FieldProps> = ({record}) => {
  return <span>공지사항 {record ? `"${record.title}"` : ''}</span>;
};

export const NoticeEdit = () => {
  return (
    <Edit title={<NoticeTitle />}>
      <SimpleForm>
        <Labeled sx={{marginBottom: 4}}>
          <DateField source="createdAt" label="등록일" showTime={true} />
        </Labeled>
        <Labeled label="앱 푸시 (수정해도 다시 발송되지 않습니다)">
          <SelectField
            source="pushStatus"
            choices={pushStatusChoices}
            emptyText="발송 안 함"
          />
        </Labeled>
        <Labeled label="앱 푸시 발송 시간">
          <DateField source="pushSentAt" showTime={true} emptyText="-" />
        </Labeled>
        <Labeled label="앱 푸시 사유" sx={{marginBottom: 4}}>
          <TextField source="pushError" emptyText="-" />
        </Labeled>
        <BooleanInput label="활성" source="enabled" />

        <TextInput
          label="제목"
          source="title"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          label="내용"
          source="content"
          multiline
          fullWidth
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
};

//
// Create
const validateNoticeCreate = (values: any) => {
  const errors: any = {};
  if (values.sendPush && !values.enabled) {
    errors.sendPush = '앱 푸시 알림을 발송하려면 공지사항을 활성화해야 합니다.';
  }
  return errors;
};

export const NoticeCreate = () => {
  return (
    <Create>
      <SimpleForm validate={validateNoticeCreate}>
        <TextInput
          label="제목"
          source="title"
          validate={[required()]}
          fullWidth
        />

        <TextInput
          label="내용"
          source="content"
          multiline
          fullWidth
          validate={[required()]}
        />

        <BooleanInput label="활성" source="enabled" defaultValue={false} />
        <BooleanInput
          label="앱 푸시 알림 발송"
          source="sendPush"
          defaultValue={false}
          helperText="체크하면 등록 시 전체 회원에게 한 번 발송됩니다. 활성 공지사항만 발송할 수 있고, 수정 시에는 다시 발송되지 않습니다."
        />
      </SimpleForm>
    </Create>
  );
};
